import styled from "styled-components";
import colors from "../../../../../../styles/colors";
import { WideBlueButton } from "../../../../../pages/CourseAuthor/Buttons";

export const AddOptionButton = styled(WideBlueButton)`
  transition: background 0.125s ease;
  &:hover {
    background: ${colors.buttonDarkBlue};
  }
`;
